import { ComponentPropsWithoutRef } from 'react';
import clsx from 'clsx';

import { Link } from './link';

/**
 * A standard paragraph text component.
 */
export function Text({ className, ...props }: ComponentPropsWithoutRef<'p'>) {
  return (
    <p
      data-slot="text"
      {...props}
      className={clsx(
        className,
        'text-base/6 text-gray-500 sm:text-sm/6 dark:text-gray-400'
      )}
    />
  );
}

/**
 * A link component specifically styled for use within body text.
 */
export function TextLink({
  className,
  ...props
}: ComponentPropsWithoutRef<typeof Link>) {
  return (
    <Link
      {...props}
      className={clsx(
        className,
        'text-gray-950 underline decoration-gray-950/50',
        'data-hover:decoration-gray-950 dark:text-white',
        'dark:decoration-white/50 dark:data-hover:decoration-white'
      )}
    />
  );
}

/**
 * A styled strong text component.
 */
export function Strong({
  className,
  ...props
}: ComponentPropsWithoutRef<'strong'>) {
  return (
    <strong
      {...props}
      className={clsx(className, 'font-medium text-gray-950 dark:text-white')}
    />
  );
}

/**
 * A styled inline code component.
 */
export function Code({
  className,
  ...props
}: ComponentPropsWithoutRef<'code'>) {
  return (
    <code
      {...props}
      className={clsx(
        className,
        'rounded-sm border border-gray-950/10 bg-gray-950/[2.5%] px-0.5',
        'text-sm font-medium text-gray-950 sm:text-[0.8125rem]',
        'dark:border-white/20 dark:bg-white/5 dark:text-white'
      )}
    />
  );
}
